import Component from '../inherited/Component';

export default class TimeCheck extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx);
  }

  mount() {
    if(!this._options.max || !this._options.min) {
        return
    }

    let currentTime = new Date().toLocaleString("en-US", {
        timeZone: "America/New_York",
        hourCycle: 'h23',
        hour: '2-digit',
        minute: '2-digit'
    }).replace('AM', '').replace('PM', '').replace(':', '').trim()
    currentTime = Number(currentTime)
    if(currentTime > Number(this._options.min) && currentTime < Number(this._options.max)) {
        this._elem.classList.add('valid')
        this._elem.classList.remove('invalid')
    } else {
        this._elem.classList.add('invalid')
        this._elem.classList.remove('valid')
    }
  }
}
